import React, { useState, useCallback } from "react";
import { message } from "antd";
import AssessmentModalEdit from "./index";
import AssessmentModalView from "./edit/edit";
import { submitAssessmentRequest } from "@/apis/supplier";
import { useModal } from "@/hooks/modals/useModal";

// ==================== 主组件 ====================
/**
 * EvaluationForm Modal 适配器组件
 * 用于将 Modal 系统的 props 转换为 EvaluationForm 组件所需的 props
 *
 * 根据是否有 taskId 来决定显示查看模式还是编辑模式：
 * - 有 taskId: 显示查看/审批模式（从工作台点击进入）- 使用 edit/edit.tsx
 * - 无 taskId: 显示新增/编辑模式（从列表页点击进入）- 使用 index.tsx
 */
const EvaluationFormModalAdapter: React.FC = () => {
  const { open, props, closeModal } = useModal("ZHUN_RU_PING_GU");
  const {
    mode,
    viewStatus,
    recordId,
    taskId,
    insId,
    onSuccess,
    isFlowFinished,
    evaluationData,
  } = props || {};

  const [submitting, setSubmitting] = useState(false);

  // 处理关闭
  const handleClose = useCallback(() => {
    closeModal();
  }, [closeModal]);

  // 处理提交（用于编辑模式）
  const handleSubmit = useCallback(
    async (submitData: any) => {
      setSubmitting(true);
      try {
        console.log("==================== 最终提交数据 ====================");
        console.log(submitData);

        // 调用API提交评估申请
        const response = await submitAssessmentRequest(submitData);
        console.log("response", response);
        if (response.data.code === 200) {
          message.success("评估申请已成功提交");
          closeModal();
          // 调用成功回调
          if (onSuccess) {
            onSuccess();
          }
        } else {
          message.error(response.data?.message || "提交失败，请重试");
        }
      } catch (error) {
        message.error("提交评估申请失败，请重试");
      } finally {
        setSubmitting(false);
      }
    },
    [onSuccess, closeModal],
  );

  // 判断是否为查看模式：有 taskId 或 insId 时为查看模式（从工作台点击进入），或从准入申请表打开时也为查看模式
  const isViewMode = !!taskId || !!insId || !!evaluationData;

  // 查看/审批模式：显示 edit/edit.tsx 组件
  if (isViewMode) {
    return (
      <AssessmentModalView
        visible={open}
        onClose={handleClose}
        onSubmit={handleClose} // 查看模式提交后直接关闭
        recordData={{
          id: recordId,
          taskId: taskId,
          insId: insId,
          ...evaluationData, // 如果有预加载的评估数据，合并到 recordData 中
        }}
        isViewOnly={viewStatus === true || !!evaluationData} // 已办状态或从准入申请表打开时为只读
        isFromVsmc={false}
        isReassess={false}
        currentPersonFlag={viewStatus === false} // 待办状态显示审批操作
        isFromGm={!!taskId} // 有 taskId 说明来自GM工作台
        isFromAdmission={!!evaluationData} // 从准入申请表打开时有预加载数据
      />
    );
  }

  // 新增/编辑模式：显示 index.tsx 组件
  const isEdit = mode === "inReview" && !isFlowFinished;
  const currentPersonFlag = mode === "inReview" && !viewStatus;
  const recordData = recordId ? { id: recordId } : null;

  return (
    <AssessmentModalEdit
      visible={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      recordData={recordData}
      taskId={taskId}
      isEdit={isEdit}
      submitting={submitting}
      currentPersonFlag={currentPersonFlag}
    />
  );
};

export default EvaluationFormModalAdapter;
